export const generalRoutes = {
  dashboard: {
    index: '/general',
  },
  truckManagement: {
    gateTransactions: {
      index: '/general/check-ins/gate-transactions/index',
      openCheckIns: '/general/check-ins/gate-transactions/index/open-check-ins',
      closedCheckIns: '/general/check-ins/gate-transactions/index/closed-check-ins',
      clearedCheckIns: '/general/check-ins/gate-transactions/index/cleared-check-ins',
      overstayedCheckIns: '/general/check-ins/gate-transactions/index/overstayed-check-ins',
      create: '/general/check-ins/gate-transactions/create',
      createPast: '/general/check-ins/gate-transactions/create-past',
      show: '/general/check-ins/gate-transactions/show/details',
      edit: '/general/check-ins/gate-transactions/edit',
      confirmClear: '/general/check-ins/gate-transactions/confirm-clear',
      confirmCheckOut: '/general/check-ins/gate-transactions/confirm-check-out',
    },
    parkingBays: {
      index: '/general/check-ins/parking-bays/index',
      create: '/general/check-ins/parking-bays/create',
      show: '/general/check-ins/parking-bays/show/details',
      edit: '/general/check-ins/parking-bays/edit',
    },
    overstayedTrucks: {
      index: '/general/check-ins/overstayed-trucks/index',
      create: '/general/check-ins/overstayed-trucks/create',
      show: '/general/check-ins/overstayed-trucks/show/details',
      edit: '/general/check-ins/overstayed-trucks/edit',
    },
    parkingBaySections: {
      index: '/general/check-ins/parking-bay-sections/index',
      create: '/general/check-ins/parking-bay-sections/create',
      show: '/general/check-ins/parking-bay-sections/show/details',
      parkingBays: '/general/check-ins/parking-bay-sections/show/parking-bays',
      edit: '/general/check-ins/parking-bay-sections/edit',
    },
    cargoCategories: {
      index: '/general/check-ins/cargo-categories/index',
      create: '/general/check-ins/cargo-categories/create',
      show: '/general/check-ins/cargo-categories/show/details',
      edit: '/general/check-ins/cargo-categories/edit',
    },
    purposes: {
      index: '/general/check-ins/purposes/index',
      create: '/general/check-ins/purposes/create',
      show: '/general/check-ins/purposes/show/details',
      edit: '/general/check-ins/purposes/edit',
    },
    transporters: {
      index: '/general/check-ins/transporters/index',
      create: '/general/check-ins/transporters/create',
      show: '/general/check-ins/transporters/show/details',
      edit: '/general/check-ins/transporters/edit',
      truck: '/general/check-ins/transporters/truck',
      receipts: '/general/check-ins/transporters/receipts',
      // Flagged Trucks + the Operations decision queue (2026-09-17). They live under the
      // transporters module because that is where the fleet is managed, but the flag is on a
      // TRUCK, never on the transporter.
      flaggedTrucks: '/general/check-ins/transporters/flagged-trucks',
      gateOverrides: '/general/check-ins/transporters/gate-overrides',
    },
    // Transporter Accounts live UNDER Truck Management (NOT Finance) — same generic accounts feature,
    // mounted at check-ins/transporter-accounts so the statement/receipts stay in this section.
    transporterAccounts: {
      index: '/general/check-ins/transporter-accounts/transporters',
      statement: '/general/check-ins/transporter-accounts/statement',
      // Resolves a transporter's own statement by holder (their invoices / receipts).
      statementByHolder: '/general/check-ins/transporter-accounts/statement-holder/TRANSPORTER',
    },
    importers: {
      index: '/general/check-ins/importers/index',
      create: '/general/check-ins/importers/create',
      show: '/general/check-ins/importers/show/details',
      edit: '/general/check-ins/importers/edit',
    },
    // Importer Accounts live UNDER Truck Management (NOT Finance) — same generic accounts feature,
    // mounted at check-ins/importer-accounts so the statement/receipts stay in this section.
    importerAccounts: {
      index: '/general/check-ins/importer-accounts/importers',
      statement: '/general/check-ins/importer-accounts/statement',
      statementByHolder: '/general/check-ins/importer-accounts/statement-holder/IMPORTER',
    },
  },
  physicalExaminations: {
    peTransactions: {
      index: '/general/physical-examinations/pe-transactions/index',
      openPeTransactions: '/general/physical-examinations/pe-transactions/index/open-pe-transactions',
      endorsedPeTransactions: '/general/physical-examinations/pe-transactions/index/endorsed-pe-transactions',
      confirmedPeTransactions: '/general/physical-examinations/pe-transactions/index/confirmed-pe-transactions',
      containerPeTransactions: '/general/physical-examinations/pe-transactions/index/container-pe-transactions',
      yardPeTransactions: '/general/physical-examinations/pe-transactions/index/yard-pe-transactions',
      create: '/general/physical-examinations/pe-transactions/create',
      show: '/general/physical-examinations/pe-transactions/show/details',
      edit: '/general/physical-examinations/pe-transactions/edit',
      endorsePhysicalExamination: '/general/physical-examinations/pe-transactions/endorse-physical-examination',
      confirmPhysicalExamination: '/general/physical-examinations/pe-transactions/confirm-physical-examination',
      confirmClose: '/general/physical-examinations/pe-transactions/confirm-close',
    },
    containerSizes: {
      index: '/general/physical-examinations/container-sizes/index',
      create: '/general/physical-examinations/container-sizes/create',
      show: '/general/physical-examinations/container-sizes/show/details',
      edit: '/general/physical-examinations/container-sizes/edit',
    },
    physicalExaminationGroups: {
      index: '/general/physical-examinations/physical-examination-groups/index',
      create: '/general/physical-examinations/physical-examination-groups/create',
      show: '/general/physical-examinations/physical-examination-groups/show/details',
      physicalExaminations: '/general/physical-examinations/physical-examination-groups/show/physical-examinations',
      edit: '/general/physical-examinations/physical-examination-groups/edit',
    },
    loadTypes: {
      index: '/general/physical-examinations/load-types/index',
      create: '/general/physical-examinations/load-types/create',
      show: '/general/physical-examinations/load-types/show/details',
      edit: '/general/physical-examinations/load-types/edit',
    },
    clearingAgents: {
      index: '/general/physical-examinations/clearing-agents/index',
      create: '/general/physical-examinations/clearing-agents/create',
      show: '/general/physical-examinations/clearing-agents/show/details',
      edit: '/general/physical-examinations/clearing-agents/edit',
    },
    clearingCompanies: {
      index: '/general/physical-examinations/clearing-companies/index',
      create: '/general/physical-examinations/clearing-companies/create',
      show: '/general/physical-examinations/clearing-companies/show/details',
      edit: '/general/physical-examinations/clearing-companies/edit',
    },
    // Clearing Company Accounts live UNDER Physical Examinations (where PE fees map) — same generic
    // accounts feature, mounted at physical-examinations/clearing-company-accounts.
    clearingCompanyAccounts: {
      index: '/general/physical-examinations/clearing-company-accounts/clearing-companies',
      statement: '/general/physical-examinations/clearing-company-accounts/statement',
      statementByHolder: '/general/physical-examinations/clearing-company-accounts/statement-holder/CLEARING_COMPANY',
    },
    physicalExamCategories: {
      index: '/general/physical-examinations/physical-exam-categories/index',
      create: '/general/physical-examinations/physical-exam-categories/create',
      show: '/general/physical-examinations/physical-exam-categories/show/details',
      edit: '/general/physical-examinations/physical-exam-categories/edit',
    },
  },
  warehouseTransactions: {
    warehouseTransactions: {
      index: '/general/warehouse-transactions/warehouse-transactions/index',
      create: '/general/warehouse-transactions/warehouse-transactions/create',
      show: '/general/warehouse-transactions/warehouse-transactions/show/details',
      edit: '/general/warehouse-transactions/warehouse-transactions/edit',
      openWarehouseTransactions: '/general/warehouse-transactions/warehouse-transactions/index/open-warehouse-transactions',
      closedWarehouseTransactions: '/general/warehouse-transactions/warehouse-transactions/index/closed-warehouse-transactions',
      confirmClose: '/general/warehouse-transactions/warehouse-transactions/confirm-close',
    },
    reconstitutions: {
      index: '/general/warehouse-transactions/reconstitutions/index',
      create: '/general/warehouse-transactions/reconstitutions/create',
      show: '/general/warehouse-transactions/reconstitutions/show/details',
      edit: '/general/warehouse-transactions/reconstitutions/edit',
      openReconstitutions: '/general/warehouse-transactions/reconstitutions/index/open-reconstitutions',
      closedReconstitutions: '/general/warehouse-transactions/reconstitutions/index/closed-reconstitutions',
      confirmedReconstitutions: '/general/warehouse-transactions/reconstitutions/index/confirmed-reconstitutions',
      confirmReconstitution: '/general/warehouse-transactions/reconstitutions/confirm-reconstitution',
      confirmClose: '/general/warehouse-transactions/reconstitutions/confirm-close',
    },
    internalWarehouseTransactions: {
      index: '/general/warehouse-transactions/internal-warehouse-transactions/index',
      create: '/general/warehouse-transactions/internal-warehouse-transactions/create',
      show: '/general/warehouse-transactions/internal-warehouse-transactions/show/details',
      edit: '/general/warehouse-transactions/internal-warehouse-transactions/edit',
      openInternalWarehouseTransactions: '/general/warehouse-transactions/internal-warehouse-transactions/index/open-internal-warehouse-transactions',
      closedInternalWarehouseTransactions: '/general/warehouse-transactions/internal-warehouse-transactions/index/closed-internal-warehouse-transactions',
      confirmClose: '/general/warehouse-transactions/internal-warehouse-transactions/confirm-close',
      transfer: '/general/warehouse-transactions/internal-warehouse-transactions/transfer',
      repack: '/general/warehouse-transactions/internal-warehouse-transactions/repack',
      transshipment: '/general/warehouse-transactions/internal-warehouse-transactions/transshipment',
    },
    warehouseTransactionGroups: {
      index: '/general/warehouse-transactions/warehouse-transaction-groups/index',
      create: '/general/warehouse-transactions/warehouse-transaction-groups/create',
      show: '/general/warehouse-transactions/warehouse-transaction-groups/show/details',
      warehouseTransactions: '/general/warehouse-transactions/warehouse-transaction-groups/show/warehouse-transactions',
      edit: '/general/warehouse-transactions/warehouse-transaction-groups/edit',
    },
    packagings: {
      index: '/general/warehouse-transactions/packagings/index',
      create: '/general/warehouse-transactions/packagings/create',
      show: '/general/warehouse-transactions/packagings/show/details',
      edit: '/general/warehouse-transactions/packagings/edit',
    },
    loadingBays: {
      index: '/general/warehouse-transactions/loading-bays/index',
      create: '/general/warehouse-transactions/loading-bays/create',
      show: '/general/warehouse-transactions/loading-bays/show/details',
      edit: '/general/warehouse-transactions/loading-bays/edit',
    },
    commodityWarehouses: {
      create: '/general/warehouse-transactions/commodity-warehouses/create',
      edit: '/general/warehouse-transactions/commodity-warehouses/edit',
    },
    commodityPackagings: {
      create: '/general/warehouse-transactions/commodity-packagings/create',
      edit: '/general/warehouse-transactions/commodity-packagings/edit',
    },
    warehouses: {
      dashboard: '/general/warehouse-transactions/warehouses',
      index: '/general/warehouse-transactions/warehouses/index',
      create: '/general/warehouse-transactions/warehouses/create',
      show: '/general/warehouse-transactions/warehouses/show/details',
      commodityWarehouses: '/general/warehouse-transactions/warehouses/show/commodity-warehouses',
      stacks: '/general/warehouse-transactions/warehouses/show/stacks',
      edit: '/general/warehouse-transactions/warehouses/edit',
    },
    commodities: {
      index: '/general/warehouse-transactions/commodities/index',
      create: '/general/warehouse-transactions/commodities/create',
      show: '/general/warehouse-transactions/commodities/show/details',
      commodityWarehouses: '/general/warehouse-transactions/commodities/show/commodity-warehouses',
      commodityPackagings: '/general/warehouse-transactions/commodities/show/commodity-packagings',
      edit: '/general/warehouse-transactions/commodities/edit',
    },
    stacks: {
      index: '/general/warehouse-transactions/stacks/index',
      allStacks: '/general/warehouse-transactions/stacks/index/all-stacks',
      reconciliation: '/general/warehouse-transactions/stacks/index/reconciliation',
      create: '/general/warehouse-transactions/stacks/create',
      show: '/general/warehouse-transactions/stacks/show/details',
      edit: '/general/warehouse-transactions/stacks/edit',
    },
    grades: {
      index: '/general/warehouse-transactions/grades/index',
      create: '/general/warehouse-transactions/grades/create',
      show: '/general/warehouse-transactions/grades/show/details',
      edit: '/general/warehouse-transactions/grades/edit',
    },
    loadingFormats: {
      index: '/general/warehouse-transactions/loading-formats/index',
      create: '/general/warehouse-transactions/loading-formats/create',
      show: '/general/warehouse-transactions/loading-formats/show/details',
      edit: '/general/warehouse-transactions/loading-formats/edit',
    },
    unitOfMeasures: {
      index: '/general/warehouse-transactions/unit-of-measures/index',
      create: '/general/warehouse-transactions/unit-of-measures/create',
      show: '/general/warehouse-transactions/unit-of-measures/show/details',
      edit: '/general/warehouse-transactions/unit-of-measures/edit',
    },
    commodityCategories: {
      index: '/general/warehouse-transactions/commodity-categories/index',
      create: '/general/warehouse-transactions/commodity-categories/create',
      show: '/general/warehouse-transactions/commodity-categories/show/details',
      edit: '/general/warehouse-transactions/commodity-categories/edit',
    },
    towns: {
      index: '/general/warehouse-transactions/towns/index',
      create: '/general/warehouse-transactions/towns/create',
      show: '/general/warehouse-transactions/towns/show/details',
      edit: '/general/warehouse-transactions/towns/edit',
    },
    warehouseContracts: {
      index: '/general/warehouse-transactions/warehouse-contracts/index',
      create: '/general/warehouse-transactions/warehouse-contracts/create',
      show: '/general/warehouse-transactions/warehouse-contracts/show/details',
      edit: '/general/warehouse-transactions/warehouse-contracts/edit',
    },
    warehouseClients: {
      index: '/general/warehouse-transactions/warehouse-clients/index',
      add: '/general/warehouse-transactions/warehouse-clients/add',
      show: '/general/warehouse-transactions/warehouse-clients/show',
      accounts: '/general/warehouse-transactions/warehouse-clients/accounts',
      accountStatement: '/general/warehouse-transactions/warehouse-clients/accounts/statement',
    },
  },
  containerManagement: {
    containerTransactions: {
      index: '/general/container-management/container-transactions/index',
      records: '/general/container-management/container-transactions/records',
      containerView: '/general/container-management/container-transactions/containers',
      openContainerTransactions: '/general/container-management/container-transactions/index/open-container-transactions',
      clearedContainerTransactions: '/general/container-management/container-transactions/index/cleared-container-transactions',
      closedContainerTransactions: '/general/container-management/container-transactions/index/closed-container-transactions',
      overstayedContainerTransactions: '/general/container-management/container-transactions/index/overstayed-container-transactions',
      create: '/general/container-management/container-transactions/create',
      show: '/general/container-management/container-transactions/show/details',
      edit: '/general/container-management/container-transactions/edit',
      confirmClear: '/general/container-management/container-transactions/confirm-clear',
      confirmClose: '/general/container-management/container-transactions/confirm-close',
    },
    accounts: {
      containers: '/general/container-management/accounts/containers',
      statement: '/general/container-management/accounts/statement',
    },
    clients: {
      index: '/general/container-management/clients/index',
      create: '/general/container-management/clients/create',
      show: '/general/container-management/clients/show/details',
      clientWarehouses: '/general/container-management/clients/show/client-warehouses',
      runningStatement: '/general/container-management/clients/show/running-statement',
      edit: '/general/container-management/clients/edit',
    },
    clientWarehouses: {
      create: '/general/warehouse-transactions/client-warehouses/create',
      edit: '/general/warehouse-transactions/client-warehouses/edit',
    },
    loadPorts: {
      index: '/general/container-management/load-ports/index',
      create: '/general/container-management/load-ports/create',
      show: '/general/container-management/load-ports/show/details',
      edit: '/general/container-management/load-ports/edit',
    },
    containerTransportations: {
      index: '/general/container-management/container-transportations/index',
      create: '/general/container-management/container-transportations/create',
      show: '/general/container-management/container-transportations/show/details',
      edit: '/general/container-management/container-transportations/edit',
    },
    containerTransactionTypes: {
      index: '/general/container-management/container-transaction-types/index',
      create: '/general/container-management/container-transaction-types/create',
      show: '/general/container-management/container-transaction-types/show/details',
      edit: '/general/container-management/container-transaction-types/edit',
    },
    containerTransactionStatuses: {
      index: '/general/container-management/container-transaction-statuses/index',
      create: '/general/container-management/container-transaction-statuses/create',
      show: '/general/container-management/container-transaction-statuses/show/details',
      edit: '/general/container-management/container-transaction-statuses/edit',
    },
    containerTransactionActions: {
      index: '/general/container-management/container-transaction-actions/index',
      create: '/general/container-management/container-transaction-actions/create',
      show: '/general/container-management/container-transaction-actions/show/details',
      edit: '/general/container-management/container-transaction-actions/edit',
    },
    shippingLines: {
      index: '/general/container-management/shipping-lines/index',
      create: '/general/container-management/shipping-lines/create',
      show: '/general/container-management/shipping-lines/show/details',
      edit: '/general/container-management/shipping-lines/edit',
    },
    specialContainerClients: {
      index: '/general/container-management/special-container-clients/index',
      create: '/general/container-management/special-container-clients/create',
      show: '/general/container-management/special-container-clients/show/details',
      edit: '/general/container-management/special-container-clients/edit',
    },
  },
  finance: {
    dashboard: '/general/finance',
    statement: '/general/finance/statement',
    priceList: '/general/finance/price-list/index',
    receiptReprint: '/general/finance/receipt-reprint/index',
    cashUp: '/general/finance/cash-up/index',
    invoices: {
      index: '/general/finance/invoices/index',
      create: '/general/finance/invoices/create',
      show: '/general/finance/invoices/show/details',
      edit: '/general/finance/invoices/edit',
    },
    accounts: {
      warehouseClients: '/general/finance/accounts/warehouse-clients',
      transporters: '/general/finance/accounts/transporters',
      containers: '/general/finance/accounts/containers',
      importers: '/general/finance/accounts/importers',
      clearingCompanies: '/general/finance/accounts/clearing-companies',
      statement: '/general/finance/accounts/statement',
    },
  },
  userManagement: {
    users: {
      index: '/general/user-management/users/index',
      create: '/general/user-management/users/create',
      show: '/general/user-management/users/show/details',
      permissions: '/general/user-management/users/show/permissions',
      edit: '/general/user-management/users/edit',
      changePassword: '/general/user-management/users/change-password',
      sendPasswordResetEmail: '/general/user-management/users/send-password-reset-email',
      sendUserInviteEmail: '/general/user-management/users/send-user-invite-email',
    },
    roles: {
      index: '/general/user-management/roles/index',
      create: '/general/user-management/roles/create',
      show: '/general/user-management/roles/show/details',
      permissions: '/general/user-management/roles/show/permissions',
      edit: '/general/user-management/roles/edit',
    },
    permissionRoles: {
      create: '/general/user-management/permission-roles/create',
      edit: '/general/user-management/permission-roles/edit',
    },
    permissionUsers: {
      create: '/general/user-management/permission-users/create',
      edit: '/general/user-management/permission-users/edit',
    },
    permissions: {
      index: '/general/user-management/permissions/index',
      create: '/general/user-management/permissions/create',
      show: '/general/user-management/permissions/show/details',
      permissions: '/general/user-management/permissions/show/permissions',
      edit: '/general/user-management/permissions/edit',
    },
  },
  administration: {
    auditFlow: {
      index: '/general/administration/audit-flow/index',
      show: '/general/administration/audit-flow/show/details',
    },
  },
  profile: {
    profile: {
      profile: '/general/profile/profile/profile/details',
      profile_activity: '/general/profile/profile/profile/activity',
      profile_password: '/general/profile/profile/profile/password',
    },
  },
  help: {
    tickets: {
      index: '/general/help/tickets/index',
      create: '/general/help/tickets/create',
      show: '/general/help/tickets/show/details',
    },
  },
  notifications: {
    index: '/general/notifications/index',
  },
  account_settings: {
    general_settings: {
      edit_details: '/general/settings/companies/edit-details',
      edit_settings: '/general/settings/companies/edit-settings',
      general_details: '/general/settings/companies/show/company-details',
      general_settings: '/general/settings/companies/show/company-settings',
      general_categories: '/general/settings/companies/show/general-categories',
      general_history: '/general/settings/companies/show/general-history',
    },
  },
  reports: {
    gateControlSheet: {
      index: '/general/reports/gate-control-sheet/index'
    },
    dailyReconciliationStatement: {
      index: '/general/reports/daily-reconciliation-statement/index'
    },
    clearedGateControlSheet: {
      index: '/general/reports/cleared-gate-control-sheet/index'
    },
    closedGateControlSheet: {
      index: '/general/reports/closed-gate-control-sheet/index'
    },
    dailyStockReport: {
      index: '/general/reports/daily-stock-report/index',
      for_commodity: '/general/reports/daily-stock-report/for-commodity'
    },
    clientsMonthlyRentalReport: {
      index: '/general/reports/monthly-warehouse-rental-report/index',
    },
    containersReport: {
      index: '/general/reports/containers-report/index'
    },
    physicalExaminationReport: {
      index: '/general/reports/physical-examination-report/index'
    },
    physicalExaminationByCategory: {
      index: '/general/reports/physical-examination-by-category/index'
    },
    physicalExaminationByContainerSize: {
      index: '/general/reports/physical-examination-by-container-size/index'
    },
    stockByWarehouse: {
      index: '/general/reports/stock-by-warehouse/index',
      for_commodity: '/general/reports/stock-by-warehouse/for-commodity-for-warehouse'
    },
    stockForStack: {
      for_warehouse: '/general/reports/stock-for-stack/for-warehouse-for-stack',
    },
    stockByBatchNumber: {
      index: '/general/reports/stock-by-batch-number/index',
      for_commodity: '/general/reports/stock-by-batch-number/for-commodity-for-batch-number'
    },
    stockByCategory: {
      index: '/general/reports/stock-by-category/index',
    },
  },
};
